import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=3665d911&scoped=true&"
import script from "./DropdownMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=3665d911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665d911",
  null
  
)

export default component.exports